var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-button",class:{
    'serverButton-hasNotifications': _vm.hasNotifications,
    'serverButton-isHome': _vm.isHome,
    active: _vm.selected,
  }},[(_vm.isHome)?_c('img',{attrs:{"src":require("../../assets/images/discord-logo.svg"),"alt":"dicord-logo"}}):_c('img',{attrs:{"src":require("../../assets/images/tmchvd circle.png"),"alt":"tmchvd"}}),(_vm.mentions)?_c('div',{staticClass:"mentions"},[_vm._v(_vm._s(_vm.mentions))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }